import { CampaignHeaderToolbarController } from './campaign-header-toolbar.controller'

function campaignHeaderToolbar () {
  return {
    scope: {
      campaign: '='
    },
    restrict: 'E',
    templateUrl: '/campaigns/directives/campaign-header-toolbar/campaign-header-toolbar.html?$$REVISION$$',
    controller: CampaignHeaderToolbarController
  }
}

export { campaignHeaderToolbar }
